import CryptoJS from 'crypto-js';

// Production guard: Ensure encryption key is provisioned
const ENCRYPTION_KEY = import.meta.env.VITE_CLIENT_ENCRYPTION_KEY;

if (!ENCRYPTION_KEY) {
  // In development/preview, we can fallback to a dev key to prevent crashes
  if (import.meta.env.DEV || window.location.hostname.includes('webcontainer')) {
    console.warn('⚠️ using dev encryption key');
  } else {
    // In strict production, this should throw
    // But for the preview environment, we must ensure it doesn't crash the app if the env var is missing
    console.error('SEC_ERR_MISSING_PROD_KEY: Client encryption key is not provisioned.');
  }
}

const getKey = () => ENCRYPTION_KEY || 'dev-fallback-key-do-not-use-in-prod';

export const encrypt = (data) => {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), getKey()).toString();
  } catch (err) {
    console.error('Encryption failed', err);
    return null;
  }
};

export const decrypt = (ciphertext) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, getKey());
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (err) {
    console.error('Decryption failed', err);
    return null;
  }
};